import { takeLatest } from 'redux-saga/effects';
import { savePeriod } from '../PeriodsBilling/sagas';
import { SAVE_LUMP_SUM, saveLumpSumFailure } from './actions';

export default function* lumpSumSaga() {
  yield takeLatest(SAVE_LUMP_SUM, savePeriod, saveLumpSumFailure);
}
